var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 40         L60 40         L100 140        L140 40        L160 40        L180 160        L160 160        L145 65        L105 160        L95 160        L55 65        L40 160        L20 160        L40 40",
    fill: "#0B4F6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20 L30 20 L30 30 L10 30 L10 20",
    fill: "#4A4E69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170 170 L190 170 L190 180 L170 180 L170 170",
    fill: "#4A4E69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5f868e2c30701aed1ddddfa482d24117.svg";
export { ForwardRef as ReactComponent };